(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5160],{

/***/ 84597:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/signature/pdf-tools/pdf-to-jpeg",
      function () {
        return __webpack_require__(91051);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 56130:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ CalculatorBlogs_Blog; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
// EXTERNAL MODULE: ./node_modules/react-icons/ai/index.esm.js
var index_esm = __webpack_require__(8193);
;// CONCATENATED MODULE: ./components/CalculatorBlogs/BlogCard.jsx




const BlogCard = (param)=>{
    let { question , answer  } = param;
    const [blogVisible, setBlogVisible] = (0,react.useState)(true);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex mb-[30px] pb-[30px] gap-[20px] border-b border-b-gray-300",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                onClick: ()=>blogVisible ? setBlogVisible(false) : setBlogVisible(true),
                className: "pt-[5px] text-[20px] md:text-[35px] w-fit cursor-pointer",
                children: blogVisible ? /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* AiOutlineMinus */.ywL, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* AiOutlinePlus */.Lfi, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "question text-[25px] md:text-[30px] mb-[20px] font-medium",
                        children: question
                    }),
                    blogVisible ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "answer text-[16px] md:text-[18px] font-light text-gray-700",
                        children: answer
                    }) : ""
                ]
            })
        ]
    });
};
/* harmony default export */ var CalculatorBlogs_BlogCard = (BlogCard);

;// CONCATENATED MODULE: ./components/CalculatorBlogs/Blog.jsx



const Blog = (param)=>{
    let { heading , BlogData , width ="lg:w-[850px]"  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "w-[100%] mx-auto md:w-[80%] ".concat(width),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                className: "text-[25px] md:text-[40px] text-center font-bold mb-14 mx-auto",
                children: heading
            }),
            BlogData.map((blog)=>{
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(CalculatorBlogs_BlogCard, {
                    question: blog.question,
                    answer: blog.answer
                }, blog.id);
            })
        ]
    });
};
/* harmony default export */ var CalculatorBlogs_Blog = (Blog);


/***/ }),

/***/ 3224:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _constants_signature__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(24599);





const PdfToolsLinks = ()=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "w-full flex flex-col justify-center items-center",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                className: "text-center text-2xl md:text-4xl text-gray-800 mb-10",
                children: "Other PDF tools offered by BoloForms"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "max-w-[1280px] mx-auto flex justify-center items-center flex-wrap gap-4",
                children: _constants_signature__WEBPACK_IMPORTED_MODULE_4__/* .signatureTools.map */ .kn.map((tool, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                        href: tool.url,
                        className: "w-[220px] h-[80px] bg-white border rounded-xl drop-shadow-md px-4 hover:shadow-xl transition duration-500 ease-in-out transform hover:-translate-y-1 hover:scale-105 z-0",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "w-full h-full grid place-items-center text-xl text-gray-600",
                            children: tool.title
                        })
                    }, index))
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PdfToolsLinks);


/***/ }),

/***/ 91051:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var pdfjs_dist_legacy_build_pdf_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78783);
/* harmony import */ var pdfjs_dist_legacy_build_pdf_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(pdfjs_dist_legacy_build_pdf_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_icons_ai__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(8193);
/* harmony import */ var react_icons_fa__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(89583);
/* harmony import */ var jszip__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(55733);
/* harmony import */ var jszip__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(jszip__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _signature_module_css__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(10411);
/* harmony import */ var _signature_module_css__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(_signature_module_css__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var _components_CalculatorBlogs_Blog__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(56130);
/* harmony import */ var _components_SignaturePopup__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(86318);
/* harmony import */ var _components_PdfToolsLinks__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(3224);
/* harmony import */ var _components_PdfTools_UploadFile__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(86297);
/* harmony import */ var _components_PdfTools_Steps__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(2561);
/* harmony import */ var _components_PdfTools_WhyChooseBolosign__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(80383);
/* harmony import */ var _components_PdfTools_PricingCards__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(23278);
/* harmony import */ var _components_PdfTools_TryBolosign__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(86658);
/* harmony import */ var _components_PdfTools_OtherPdfTools__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(41441);
/* harmony import */ var _components_Cards_FaqCard__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(86585);
/* harmony import */ var react_icons_lu__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(1451);
/* harmony import */ var react_icons_md__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(5434);























pdfjs_dist_legacy_build_pdf_js__WEBPACK_IMPORTED_MODULE_3__.GlobalWorkerOptions.workerSrc = "//unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js";
const steps = [
    {
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_lu__WEBPACK_IMPORTED_MODULE_15__/* .LuUpload */ .oSY, {}),
        title: "Upload Your PDF",
        description: "To change a PDF to a JPG, start by uploading your files. You can drag and drop your PDFs into the conversion area or use the 'Select Files' button to choose which documents to upload."
    },
    {
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_md__WEBPACK_IMPORTED_MODULE_16__/* .MdPublishedWithChanges */ ._Vo, {}),
        title: "Convert Your PDFs",
        description: "Our tool will begin the conversion process now you can export PDF as JPEG without compromising on quality."
    },
    {
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_lu__WEBPACK_IMPORTED_MODULE_15__/* .LuDownload */ .$0x, {}),
        title: "Download Your PDF",
        description: "Download your JPG files directly to your device. Our platform ensures that every PDF to JPG conversion is handled with precision, ensuring high-quality results."
    }
];
const reasons = [
    {
        image: "orientation_autosaving.png",
        title: "Orientation autosaving",
        description: "Our tool will autosave the orientation of the pages in your file to ensure you don't have to rotate your files when you export a PDF as a JPG."
    },
    {
        image: "batch.png",
        title: "Batch Conversion",
        description: "Convert multiple PDF files to JPG format simultaneously."
    },
    {
        image: "high_quality.png",
        title: "High Quality",
        description: "We ensure that your JPGs maintain high resolution and quality."
    },
    {
        image: "portable_resolution.png",
        title: "Portable solution",
        description: "Our solution allows you to save a PDF as a PNG on any browser and device. No need to download any software or create an account."
    }
];
const faqData = [
    {
        faqQuestion: "How do I convert a PDF to a JPEG using BoloSign?",
        faqAnswer: "To convert a PDF to a JPEG, simply upload your file to our BoloSign converter. Drag and drop your PDF into the designated area or click 'Select Files' to choose your PDF. Once uploaded, the file will automatically be converted to JPEG format which you can download immediately."
    },
    {
        faqQuestion: "What should I do to change a PDF to a JPG without losing quality?",
        faqAnswer: "To ensure high-quality outputs when converting your PDF to JPG, use BoloSign's PDF to JPG converter which maintains the resolution and quality of your original document. Just upload your PDF, and let our tool handle the optimal conversion settings automatically."
    },
    {
        faqQuestion: "How to save a PDF as JPEG for free?",
        faqAnswer: "BoloSign allows you to save your PDF as a JPEG for free without any hidden charges. Access our PDF to JPG tool, upload your PDF, and convert it to JPEG in a few clicks. There is no need to register or provide an email address, making it both simple and secure."
    }
];
const PdfToJpeg = ()=>{
    const [pdf, setPdf] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    const [images, setImages] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    const [pageRendering, setPageRendering] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [loader, setLoader] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [pagesToDownload, setPagesToDownload] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    const [signaturePopup, setSignaturePopup] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [error, setError] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const scrollToPreview = ()=>{
        const element = document.querySelector(".preview-pdfs");
        if (element) {
            element.scrollIntoView({
                behavior: "smooth"
            });
        }
    };
    const handleDrop = (e)=>{
        e.preventDefault();
        const file = e.dataTransfer.files[0];
        showPdf(file);
        scrollToPreview();
    };
    const handlePdfUpload = (e)=>{
        const file = e.target.files[0];
        showPdf(file);
        if (file) {
            scrollToPreview();
        }
    };
    const handleFileUpload = (files)=>{
        if (files[0]) {
            scrollToPreview();
        }
        showPdf(files[0]);
        setError("");
    };
    const showPdf = async (file)=>{
        try {
            const uri = URL.createObjectURL(file);
            const _PDF_DOC = await (0,pdfjs_dist_legacy_build_pdf_js__WEBPACK_IMPORTED_MODULE_3__.getDocument)({
                url: uri
            }).promise;
            setPagesToDownload(Array.from({
                length: _PDF_DOC.numPages
            }, (_, i)=>i + 1));
            setPdf(_PDF_DOC);
        } catch (error) {
            alert(error.message);
        }
    };
    const renderPage = async ()=>{
        setPageRendering(true);
        const imagesList = [];
        for(let i = 1; i <= pdf.numPages; i++){
            const page = await pdf.getPage(i);
            const viewport = page.getViewport({
                scale: 1
            });
            const canvas = document.createElement("canvas");
            canvas.height = viewport.height;
            canvas.width = viewport.width;
            const renderContext = canvas.getContext("2d");
            await page.render({
                canvasContext: renderContext,
                viewport: viewport
            }).promise;
            const img = canvas.toDataURL("image/jpeg");
            imagesList.push(img);
        }
        setImages(imagesList);
        setPageRendering(false);
    };
    const downloadImages = ()=>{
        if (!images.length > 0) return;
        setLoader(true);
        const fileName = "pdf-to-jpeg.zip";
        const zip = new (jszip__WEBPACK_IMPORTED_MODULE_4___default())();
        const imgFolder = zip.folder("images");
        for(let i = 0; i < images.length; i++){
            if (!pagesToDownload.includes(i + 1)) continue;
            const base64 = images[i].replace(/^data:image\/(jpeg|jpg);base64,/, "");
            imgFolder.file("image-".concat(i + 1, ".jpeg"), base64, {
                base64: true
            });
        }
        zip.generateAsync({
            type: "blob"
        }).then((content)=>{
            const url = window.URL.createObjectURL(content);
            const a = document.createElement("a");
            a.href = url;
            a.download = fileName;
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
        });
        setLoader(false);
        setTimeout(()=>{
            setSignaturePopup(true);
        }, 2000);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        pdf && renderPage();
    }, [
        pdf
    ]);
    const addOrRemovePage = (page)=>{
        if (pagesToDownload.includes(page)) {
            setPagesToDownload(pagesToDownload.filter((p)=>p !== page));
        } else {
            setPagesToDownload([
                ...pagesToDownload,
                page
            ]);
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "w-full mt-20 sm:mt-24",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        charSet: "utf-8"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: "PDF to JPEG Tool | BoloForms"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: "Convert PDF files to JPEG images online for free. No software installation required."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "keywords",
                        content: "pdf to image, pdf to images, pdf to photo, pdf to image boloforms, pdf to JPEG boloforms, pdf to JPEG, pdf to JPEG converter, convert pdf to JPEG, pdf to JPEG online, pdf to JPEG free, pdf to JPEG tool, pdf to JPEG conversion, pdf to JPEG converter online, pdf to JPEG converter free, pdf to JPEG converter tool"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "author",
                        content: "BoloForms"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "viewport",
                        content: "width=device-width, initial-scale=1.0"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "canonical",
                        href: "https://www.bolosign.com/signature/pdf-tools/pdf-to-jpeg"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:title",
                        content: "PDF to JPEG Tool | BoloForms"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:description",
                        content: "Convert PDF files to JPEG images online for free. No software installation required."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:url",
                        content: "https://www.bolosign.com/signature/pdf-tools/pdf-to-jpeg"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:site_name",
                        content: "BoloForms"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:image:width",
                        content: "1200"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:image:height",
                        content: "630"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:image:alt",
                        content: "BoloForms"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:type",
                        content: "website"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:locale",
                        content: "en_US"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:card",
                        content: "summary_large_image"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:site",
                        content: "@BoloForms"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:creator",
                        content: "@BoloForms"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:title",
                        content: "PDF to JPEG Tool | BoloForms"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:description",
                        content: "Convert PDF files to JPEG images online for free. No software installation required."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "canonical",
                        href: "https://www.bolosign.com/signature/pdf-tools/pdf-to-jpeg/"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "w-full",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_PdfTools_UploadFile__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                        heading: "Convert Your PDF to JPG Effortlessly with BoloSign",
                        description: "Easily transform your PDF files into high-quality JPG images with our free online converter. Whether you need to convert a single PDF or batch process multiple documents, BoloSign makes it simple and secure.",
                        bgColor: "bg-[#e5dbfd]",
                        btnColor: "bg-[#ab8cfc]",
                        image: "pdf-to-jpeg.png",
                        handleFileUpload: handleFileUpload,
                        multipleFiles: false
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "preview-pdfs"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        // id="preview-pdfs"
                        className: "max-w-[1280px] mx-auto flex flex-col gap-14 justify-center items-center mt-12 sm:mt-20 px-4 sm:px-8",
                        children: [
                            pdf && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h1", {
                                        className: "text-2xl sm:text-3xl font-light text-center text-gray-900",
                                        children: [
                                            "Disselect Pages that you ",
                                            "don't",
                                            " want"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "relative w-full h-[400px] flex flex-wrap justify-center gap-4 border-2 md:px-10 py-4 md:py-14 md:rounded-xl overflow-y-scroll scrollbar-thin scrollbar-thumb-violet-500 scrollbar-rounded-[12px]",
                                        children: [
                                            images.map((image, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "border w-fit relative flex justify-center items-center flex-wrap",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "border-1 p-4 bg-white w-[230px]",
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                                id: "image-generated",
                                                                src: image,
                                                                alt: "pdfImage",
                                                                className: "w-[full"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "absolute top-2 left-2 w-8 h-8 bg-black rounded-full text-xl text-white flex justify-center items-center cursor-pointer",
                                                            children: index + 1
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            onClick: ()=>addOrRemovePage(index + 1),
                                                            className: "absolute top-2 right-2 w-8 h-8 ".concat(pagesToDownload.includes(index + 1) ? "bg-violet-500" : "bg-gray-400", " rounded-full text-xl text-white flex justify-center items-center cursor-pointer"),
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_ai__WEBPACK_IMPORTED_MODULE_17__/* .AiOutlineCheck */ .bzc, {})
                                                        })
                                                    ]
                                                }, index)),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                id: "page-loader",
                                                className: "".concat(pageRendering ? "absolute w-full top-0 left-0 h-full flex justify-center items-center bg-white z-50" : "hidden"),
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                                                    "aria-hidden": "true",
                                                    className: "w-14 h-14 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-violet-600",
                                                    viewBox: "0 0 100 101",
                                                    fill: "none",
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                            d: "M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z",
                                                            fill: "currentColor"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                            d: "M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z",
                                                            fill: "currentFill"
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            images.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                id: "split-pdfs",
                                className: "w-full",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                    onClick: downloadImages,
                                    className: "bg-[#e5dbfd] mx-auto w-full sm:w-[350px] py-4 text-xl rounded-lg font-semibold text-gray-900 flex items-center justify-center gap-4 hover:opacity-90 border-2 border-gray-900",
                                    children: loader ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "flex items-center text-gray-900 space-x-2 ".concat((_signature_module_css__WEBPACK_IMPORTED_MODULE_18___default().loader)),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "",
                                                children: "Downloading"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "w-2 h-2 bg-gray-900 rounded-full animate-bounce"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "w-2 h-2 bg-gray-900 rounded-full animate-bounce"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "w-2 h-2 bg-gray-900 rounded-full animate-bounce"
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                        children: [
                                            "Download Zip ",
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_fa__WEBPACK_IMPORTED_MODULE_19__/* .FaDownload */ .aBF, {
                                                className: "text-3xl"
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "w-full px-4 sm:px-8 mt-12",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_PdfTools_Steps__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                            heading: "How to Convert PNG to PDF?",
                            steps: steps
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "w-full max-w-screen-xl mx-auto px-4 sm:px-8 mt-16 sm:mt-20",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_PdfTools_WhyChooseBolosign__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                            heading: "BoloSign PDF to JPG Converter Features",
                            description: "Our platform is designed with simplicity in mind, making it easy for anyone to convert PND to JPG without any technical expertise. Also, we prioritize your privacy and data protection by processing and storing your documents securely.",
                            reasons: reasons
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "w-full max-w-screen-xl mx-auto px-4 sm:px-8 mt-16 sm:mt-32",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_PdfTools_PricingCards__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                            heading: "Looking for more than PDF tools?",
                            description: "Join 50,000+ teams who are already signing and accelerating their document workflow with BoloSign."
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "w-full max-w-screen-xl mx-auto px-4 sm:px-8 mt-16 sm:mt-32",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_PdfTools_TryBolosign__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                            heading: "Try BoloSign Free for 7 Days!",
                            bgColor: "bg-[#e5dbfd]"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "w-full px-4 sm:px-8 mt-16 sm:mt-32",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_PdfTools_OtherPdfTools__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                            heading: "Other PDF Editing Tools",
                            description: "Free online PDF tools to merge, split, rotate, compress, convert, and many more.\nManage your daily PDF tasks with our online PDF tools."
                        })
                    }),
                    signaturePopup && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_SignaturePopup__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        onPopupClose: ()=>setSignaturePopup(false),
                        source: "PDF_TO_JPEG"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "w-full max-w-screen-xl mx-auto px-4 sm:px-8 mt-16 sm:mt-32 flex flex-col gap-12",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                className: "text-center font-bold leading-[45px] sm:leading-[55px] lg:leading-[70px] text-[36px] sm:text-[48px] lg:text-[60px]",
                                children: "Frequently Asked Questions"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "max-w-screen-lg mx-auto w-full flex flex-col gap-6",
                                children: faqData.map((faq, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Cards_FaqCard__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                        faqQuestion: faq.faqQuestion,
                                        faqAnswer: faq.faqAnswer
                                    }, index))
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (PdfToJpeg);


/***/ }),

/***/ 92703:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(50414);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),

/***/ 45697:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) { var throwOnDirectAccess, ReactIs; } else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(92703)();
}


/***/ }),

/***/ 50414:
/***/ (function(module) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),

/***/ 14601:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 32767:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 28251:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 57677:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 87324:
/***/ (function() {

/* (ignored) */

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2013,4617,7627,9570,4824,3758,2749,7499,4599,2145,9774,2888,179], function() { return __webpack_exec__(84597); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);